// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
}
.outer-section-profile {
  width: 100%;

  border-radius: 10px;
  display: flex;
}
.profile-icon_img {
  font-size: 75px;
  margin-right: 10px;
  color: #84c7ae;
}

.profile-main-section {
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
  width: 20%;
  min-width: 150px;
  height: auto;
  margin: 5px;

  border-radius: 10px;
}
.profile-user-name {
  text-align: center;
  padding: 13px;
}
.user-data-sections {
  box-sizing: border-box;
  width: 78%;

  border-radius: 10px;
  height: 480px;
  min-height: 350px;
  margin: 5px;
}
.circle-img-section {
  height: 70px;
  width: 70px;
  border-radius: 50%;
  margin: auto;
  margin-top: 10px;
  z-index: 1;
}
.circle-img-section img {
  height: 70px;
  width: 70px;
  border-radius: 50%;
}

.user-profile-data h3 {
  color: rgb(107, 105, 105);
  font-size: 1.4vw;
}
.span {
  display: flex;
  flex-direction: column;

  font-size: 0.8rem;
  margin-bottom: 12px;
  margin-left: 20px;
  width: 82%;
  overflow: auto;
  opacity: 70%;
}
.span::-webkit-scrollbar {
  display: none;
}
.designation-value,
.phone-value,
.email-value,
.department-value,
.age-value,
.manager-value {
  color: #0d7c66;
  font-size: 0.8rem;
  font-weight: 700;
}

@media screen and (min-width: 768px) {
  .outer-section-profile {
    flex-direction: row;
    align-items: center;
    height: auto;
  }

  .profile-main-section {
    width: 21%;
  }

  .user-data-sections {
    width: 81%;
  }

  .user-profile-data h3 {
    font-size: 0.8rem;
  }

  .span {
    width: 90%;
  }
}

@media screen and (max-width: 767px) {
  .outer-section-profile {
    flex-direction: column; /* Stack sections vertically */
  }

  .profile-main-section {
    width: 100%;
    margin-bottom: 15px; /* Add space between stacked sections */
  }

  .user-data-sections {
    width: 100%;
    height: auto; /* IMPORTANT: Allow height to grow with content */
    min-height: unset; /* Remove desktop min-height constraint */
  }

  .circle-img-section {
    height: 77px;
    width: 73px;
    display: flex;
  }

  .user-profile-data h3 {
    font-size: 1.3rem; /* Adjusted for better mobile readability */
    margin-top: 24px;
  }

  .span {
    font-size: 0.9rem;
    width: 100%;
    margin-left: 0; /* Reset left margin for full width */
    padding: 0 15px; /* Add horizontal padding for spacing */
  }
  .profile-icon_img {
    margin-right: 10px;
  }
  .user-profile-data {
    margin-top: -10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/Profile/Profile.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,WAAW;;EAEX,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,WAAW;;EAEX,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,UAAU;;EAEV,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;;EAEtB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,cAAc;EACd,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;;;;;;EAME,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;IACE,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,sBAAsB,EAAE,8BAA8B;EACxD;;EAEA;IACE,WAAW;IACX,mBAAmB,EAAE,uCAAuC;EAC9D;;EAEA;IACE,WAAW;IACX,YAAY,EAAE,iDAAiD;IAC/D,iBAAiB,EAAE,yCAAyC;EAC9D;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,aAAa;EACf;;EAEA;IACE,iBAAiB,EAAE,2CAA2C;IAC9D,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,cAAc,EAAE,qCAAqC;IACrD,eAAe,EAAE,uCAAuC;EAC1D;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["* {\n  margin: 0px;\n  padding: 0px;\n  box-sizing: border-box;\n}\n.outer-section-profile {\n  width: 100%;\n\n  border-radius: 10px;\n  display: flex;\n}\n.profile-icon_img {\n  font-size: 75px;\n  margin-right: 10px;\n  color: #84c7ae;\n}\n\n.profile-main-section {\n  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);\n  width: 20%;\n  min-width: 150px;\n  height: auto;\n  margin: 5px;\n\n  border-radius: 10px;\n}\n.profile-user-name {\n  text-align: center;\n  padding: 13px;\n}\n.user-data-sections {\n  box-sizing: border-box;\n  width: 78%;\n\n  border-radius: 10px;\n  height: 480px;\n  min-height: 350px;\n  margin: 5px;\n}\n.circle-img-section {\n  height: 70px;\n  width: 70px;\n  border-radius: 50%;\n  margin: auto;\n  margin-top: 10px;\n  z-index: 1;\n}\n.circle-img-section img {\n  height: 70px;\n  width: 70px;\n  border-radius: 50%;\n}\n\n.user-profile-data h3 {\n  color: rgb(107, 105, 105);\n  font-size: 1.4vw;\n}\n.span {\n  display: flex;\n  flex-direction: column;\n\n  font-size: 0.8rem;\n  margin-bottom: 12px;\n  margin-left: 20px;\n  width: 82%;\n  overflow: auto;\n  opacity: 70%;\n}\n.span::-webkit-scrollbar {\n  display: none;\n}\n.designation-value,\n.phone-value,\n.email-value,\n.department-value,\n.age-value,\n.manager-value {\n  color: #0d7c66;\n  font-size: 0.8rem;\n  font-weight: 700;\n}\n\n@media screen and (min-width: 768px) {\n  .outer-section-profile {\n    flex-direction: row;\n    align-items: center;\n    height: auto;\n  }\n\n  .profile-main-section {\n    width: 21%;\n  }\n\n  .user-data-sections {\n    width: 81%;\n  }\n\n  .user-profile-data h3 {\n    font-size: 0.8rem;\n  }\n\n  .span {\n    width: 90%;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .outer-section-profile {\n    flex-direction: column; /* Stack sections vertically */\n  }\n\n  .profile-main-section {\n    width: 100%;\n    margin-bottom: 15px; /* Add space between stacked sections */\n  }\n\n  .user-data-sections {\n    width: 100%;\n    height: auto; /* IMPORTANT: Allow height to grow with content */\n    min-height: unset; /* Remove desktop min-height constraint */\n  }\n\n  .circle-img-section {\n    height: 77px;\n    width: 73px;\n    display: flex;\n  }\n\n  .user-profile-data h3 {\n    font-size: 1.3rem; /* Adjusted for better mobile readability */\n    margin-top: 24px;\n  }\n\n  .span {\n    font-size: 0.9rem;\n    width: 100%;\n    margin-left: 0; /* Reset left margin for full width */\n    padding: 0 15px; /* Add horizontal padding for spacing */\n  }\n  .profile-icon_img {\n    margin-right: 10px;\n  }\n  .user-profile-data {\n    margin-top: -10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
